import { render, staticRenderFns } from "./service-support-status.vue?vue&type=template&id=526579de&"
import script from "./service-support-status.vue?vue&type=script&lang=js&"
export * from "./service-support-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports